var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 11.25H8.125C6.36719 11.25 5 12.6562 5 14.375C5 14.7266 5.27344 15 5.625 15H13.125C13.4375 15 13.75 14.7266 13.75 14.375C13.75 12.6562 12.3438 11.25 10.625 11.25ZM9.375 10C10.7422 10 11.875 8.90625 11.875 7.5C11.875 6.13281 10.7422 5 9.375 5C7.96875 5 6.875 6.13281 6.875 7.5C6.875 8.90625 7.96875 10 9.375 10ZM19.375 12.5H18.75V16.25H19.375C19.6875 16.25 20 15.9766 20 15.625V13.125C20 12.8125 19.6875 12.5 19.375 12.5ZM19.375 2.5H18.75V6.25H19.375C19.6875 6.25 20 5.97656 20 5.625V3.125C20 2.8125 19.6875 2.5 19.375 2.5ZM19.375 7.5H18.75V11.25H19.375C19.6875 11.25 20 10.9766 20 10.625V8.125C20 7.8125 19.6875 7.5 19.375 7.5ZM15 0H3.75C2.34375 0 1.25 1.13281 1.25 2.5V17.5C1.25 18.9062 2.34375 20 3.75 20H15C16.3672 20 17.5 18.9062 17.5 17.5V2.5C17.5 1.13281 16.3672 0 15 0ZM15.625 17.5C15.625 17.8516 15.3125 18.125 15 18.125H3.75C3.39844 18.125 3.125 17.8516 3.125 17.5V2.5C3.125 2.1875 3.39844 1.875 3.75 1.875H15C15.3125 1.875 15.625 2.1875 15.625 2.5V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.dbdf7044bc3aa65a9a064262c8a71f42.svg";
export { ForwardRef as ReactComponent };